// extracted by mini-css-extract-plugin
module.exports = {"container":"terms_container__SL1Nr","title":"terms_title__SOUOf","overview":"terms_overview__PBx6b","list-section":"terms_list-section__VG74_","items":"terms_items__mLAgr"};